/**
 * AiSLAiPageView
 *
 * Page component for AiSLAiPageView
 * Path: /sl/ai
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { AiSLAiPageView as __AiSLAiPageView } from '@/components/traits/AiSLAiPageView';
import { AiSLAiAnalyticsView as __AiSLAiAnalyticsView } from '@/components/traits/AiSLAiAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface AiSLAiPageViewProps {
  // Add any page-level props here
}

export function AiSLAiPageView(_props: AiSLAiPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-ai:meta.title"],"description":["i18n/t","std-almadar-ai:meta.description"],"access":"public","indexing":"index","origin":"https://almadar.io","siteName":"Almadar","alternates":[{"locale":"en","path":"/ai"},{"locale":"ar","path":"/ar/ai"},{"locale":"sl","path":"/sl/ai"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__AiSLAiPageView config={{ initPayload: __navState }} />
          <__AiSLAiAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default AiSLAiPageView;
